import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "constants/UserRoles";

const breadcrumbStatic = [{
	name: 'Regional Phone Logs',
	url: '/phone_logs/regions',
	icon: 'dashboard'
}];

export default class RegionalPhoneLogs extends Framework.Components.View {
	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history} />

				<div className={"row"}>
					<div className={"col"}>
						<Collections.RegionalPhoneLogs
							history={this.props.history}
							showCSV={this.props.roles.includes(UserRoles.Admin)}
						/>
					</div>
				</div>
			</div>
		)
	}
}